// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"creditcard-add"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 20H2L2 10M22 10V11M22 10H2M22 10V4L2 4L2 10M6 15H9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20 15V18M20 18V21M20 18H17M20 18H23","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CreditcardAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'creditcard-add',
    ref,
    icon: element,
  },
));

CreditcardAddIcon.displayName = 'CreditcardAddIcon';

export default CreditcardAddIcon;
